import React, { Fragment } from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postWoodlandForms } from "../../redux/actions/woodlandActions";
import {
  useForm,
  determineRadioAnswers,
} from "../../common/FormCreator/helpers";

const IncidentReporting = ({ appData, postWoodlandFormsFunc }) => {
  const initialState = {
    Group11: {
      title: "An accident is described as:",
      type: "radio",
      radioOptions: [
        "A funny moment",
        "An unplanned event that results in an injury or ill-health of people, or damage or loss to property, material or the environment or a loss of business opportunity",
        "A close call",
        "Something that just happens and not to worry about it",
      ],
      mandatory: true,
    },
    Group12: {
      title: "What is the time frame that an Incident should be reported?",
      type: "radio",
      radioOptions: [
        "48 Hours",
        "24 Hours",
        "Immediately",
        "When you have time",
      ],
      mandatory: true,
    },
    Group13: {
      title: "Who should report any unsafe working practices?",
      type: "radio",
      radioOptions: [
        "Anyone who was a witnessed the unsafe act",
        "The supervisor",
        "Management",
        "Health and Safety Executive Inspectors",
      ],
      mandatory: true,
    },
    Group14: {
      title: "A near miss can be described as:",
      type: "radio",
      radioOptions: [
        "An accident that resulted in time off from work",
        "A minor accident which could have been avoided",
        "A minor accident that was unreported",
        "Something that has the potential to cause harm",
      ],
      mandatory: true,
    },
    Group15: {
      title: "What should you do if you discover an injured person?",
      type: "radio",
      radioOptions: [
        "Walk past and hope they don’t see you",
        "Try and help them, even if you don’t know what you are doing",
        "Make sure the area is safe, then call for help and report it to your supervisor/manager",
        "Record it on your phone and post it on social media",
      ],
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const woodland = appData.woodlandGroupOnboarding;
  const submitted = woodland && woodland.incidentReporting;
  const fireSafety = !!(woodland && woodland.fireSafety);
  const manualHandling = !!(woodland && woodland.manualHandling);

  const redirectBack = () => {
    history.push("/profile/edit/woodland-group-onboarding");
  };

  const handleSubmit = () => {
    const answers = determineRadioAnswers(fields);
    postWoodlandFormsFunc("incidentReporting", {
      ...answers,
      date: moment().toISOString(),
    });
    if (manualHandling && fireSafety) {
      postWoodlandFormsFunc("submit", {
        name: `${appData.firstName} ${appData.lastName}`,
        ...appData.woodlandGroupOnboarding.fireSafety,
        ...appData.woodlandGroupOnboarding.manualHandling,
        ...answers,
        date: moment().toISOString(),
      });
    }
    redirectBack();
  };

  return (
    <>
      {/* {submitted ? (
        redirectBack()
      ) : ( */}
      <FormCreatorV2
        formTitle={"Incident Reporting"}
        helper={""}
        fields={fields}
        setField={setField}
        handleCancel={() => redirectBack()}
        onboardingBranch={"woodlandBranch"}
        useSubmitText={true}
        handleSubmit={handleSubmit}
      />
      {/* )} */}
    </>
  );
};

IncidentReporting.propTypes = {
  appData: any,
  postWoodlandFormsFunc: func,
};

const mapDispatchToProps = {
  postWoodlandFormsFunc: postWoodlandForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(IncidentReporting);
